import axios from 'axios';

export const CONNECTION_STORAGE_KEY = 'qfrobt.backendConnection';

export function normalizeApiBaseUrl(value, pageProtocol = window.location.protocol) {
  const input = String(value || '').trim();
  if (!input || input === '/api') return '/api';
  let url;
  try { url = new URL(input); } catch { throw new Error('请填写完整的后端地址，例如 https://后端域名:端口'); }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
    throw new Error('后端地址仅支持 HTTP/HTTPS，请去掉账号、密码、查询参数和锚点');
  }
  if (pageProtocol === 'https:' && url.protocol !== 'https:') {
    throw new Error('当前页面使用 HTTPS，后端也需要填写 HTTPS 地址');
  }
  const pathname = url.pathname.replace(/\/+$/, '');
  return `${url.origin}${pathname.endsWith('/api') ? pathname : `${pathname}/api`}`;
}

export function getBackendPreset() {
  return process.env.REACT_APP_BACKEND_PRESET_URL || '';
}

export function getBackendConnection() {
  try {
    const saved = JSON.parse(localStorage.getItem(CONNECTION_STORAGE_KEY));
    if (saved && ['proxy', 'custom'].includes(saved.mode)) {
      if (saved.mode === 'custom') normalizeApiBaseUrl(saved.customUrl);
      return { mode: saved.mode, customUrl: saved.customUrl || '' };
    }
  } catch { /* A broken saved value must never prevent opening the settings. */ }
  const configured = process.env.REACT_APP_API_BASE_URL || '/api';
  try {
    const apiBase = normalizeApiBaseUrl(configured);
    if (apiBase !== '/api') return { mode: 'custom', customUrl: apiBase };
  } catch { /* Use the local proxy if a deployment default is invalid. */ }
  return { mode: 'proxy', customUrl: getBackendPreset() };
}

export function getApiBaseUrl(connection = getBackendConnection()) {
  return connection.mode === 'custom' ? normalizeApiBaseUrl(connection.customUrl) : '/api';
}

export function saveBackendConnection(connection) {
  const apiBase = getApiBaseUrl(connection);
  const changed = apiBase !== getApiBaseUrl();
  // A token for one backend must not be forwarded to a different backend.
  if (changed) localStorage.removeItem('token');
  localStorage.setItem(CONNECTION_STORAGE_KEY, JSON.stringify({
    mode: connection.mode,
    customUrl: connection.customUrl || ''
  }));
  return changed;
}

export async function testBackendConnection(connection) {
  const healthUrl = `${getApiBaseUrl(connection).replace(/\/api$/, '')}/health`;
  let response;
  try {
    // Probe without the authenticated API instance, cookies or a Bearer token.
    response = await axios.get(healthUrl, {
      timeout: 10000,
      withCredentials: false,
      headers: { Accept: 'application/json' }
    });
  } catch (error) {
    if (error.response?.data?.database?.status === 'disconnected') {
      throw new Error('已连接到后端，但数据库不可用，请检查后端服务');
    }
    if (error.response) throw new Error(`后端返回 HTTP ${error.response.status}，请确认填写的是后端地址`);
    if (error.code === 'ECONNABORTED') throw new Error('连接超时，请确认隧道在线并转发到后端 8000 端口');
    throw new Error('无法连接，请检查隧道、HTTPS 证书及后端允许的前端地址（CORS_ORIGIN）');
  }
  if (response.data?.status !== 'healthy' || response.data?.database?.status !== 'connected') {
    throw new Error('该地址未返回后端健康状态，请确认没有填成前端页面或隧道提示页');
  }
  return { message: '连接成功，后端和数据库正常', healthUrl };
}
